function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
export var HamburgerToggle = function(_param) /*#__PURE__*/ {
    var _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, className = _param.className, props = _objectWithoutProperties(_param, [
        "isOpen",
        "className"
    ]);
    return React.createElement("svg", _extends({
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: cx(className, "transition-all", isOpen && "rotate-45")
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M23 3.66117H0V5.66117H23V3.66117Z",
        className: cx("transition-all", isOpen && "opacity-0 translate-y-[0.4375rem]")
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M23 10.6612H0V12.6612H23V10.6612Z",
        className: cx("transition-all origin-center", isOpen && "rotate-90")
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M23 17.6612H0V19.6612H23V17.6612Z",
        className: cx("transition-all origin-center", isOpen && "translate-y-[-0.4375rem]")
    }));
};

//# sourceMappingURL=HamburgerToggle.js.map